module.exports = __webpack_public_path__ + "0d444d03d51218c0b9bea68fc05d95d1.png";